<template><BusinessPage module-key="attendance" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'AttendancePage', components: { BusinessPage } }</script>
